"use client";
import React from "react";
import { useCurrency } from "@/app/providers/currencyContext";

export const SingleProductDescriptionFocusedPrice = ({
  product,
  isGiftCardProduct,
  isRetailMerchant,
}: any) => {
  const { format } = useCurrency();

  if (!product.available) {
    return <span className="self-start pt-[2px] font-medium">Unavailable</span>;
  }

  return (
    <span
      data-testid="product-price"
      className="pt-[3px] text-sm font-medium pl-3"
    >
      {!isGiftCardProduct ? format(product.price) : "Custom Value"}
    </span>
  );
};
